jQuery(function($){
    // other product code

    $( '.woocommerce-product-rating .woocommerce-review-link' ).on("click", function(e){
        e.preventDefault();

        $('#tab_reviews').attr( 'checked', true );
        document.querySelector('#tab_reviews').scrollIntoView({ behavior: 'smooth' })

    })


    const variation = document.querySelector(".woocommerce-variation.single_variation");

    if( variation ){
        $( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
            update_variation_content(event, variation);
        });
    }

});


function update_variation_content(e, variation){
    
    let variation_template  = document.getElementById('custom-variation');

    let price               = variation_template.querySelector('.custom-price');
    let rrp_price           = variation_template.querySelector('.custom-rrp-price');
    let description         = variation_template.querySelector('.custom-description');
    let availability        = variation_template.querySelector('.custom-availability');
    
    price.innerHTML = variation.price_html;
    description.innerHTML = variation.variation_description;
    
    if( rrp_price ){
        rrp_price.innerHTML = variation.rrp_price_html;
    }

    variation_template.style.display = "block";

    // sku
    let sku = document.querySelector('#custom_sku .sku');
    if(sku){
        sku.innerHTML = variation.sku;
    }

    // Availability
    availability.innerHTML = variation.availability_html;
}